import { TrlPillAmount } from './TrlPillAmount';

export { TrlPillAmount } from './TrlPillAmount';
export default TrlPillAmount;
